import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ConfirmModal } from '../../../components/modal/confirm-modal/ConfirmModal.component';

export default function PaymentsReportsModal({ isOpen, closeModal }) {
  const history = useHistory();

  const actions = [
    {
      id: 'billed-schools-report',
      text: 'Billed Schools Report',
    },
    {
      id: 'unbilled-schools-report',
      text: 'Unbilled Schools Report',
    },
    {
      id: 'subscription-report',
      text: 'Subscription Report',
    },
    {
      id: 'cash-received-report',
      text: 'Cash Received Report',
    },
    {
      id: 'debtors-list',
      text: 'Debtors List',
    },
    {
      id: 'school-statement-report',
      text: 'School Statement',
    },
    {
      id: 'invoice-student-counts',
      text: 'Invoice Student Counts',
    },
  ];

  return (
    <ConfirmModal
      title="Payments Reports"
      isOpen={isOpen}
      closeModal={closeModal}
      secondaryActionText="Close"
      secondaryBtnClasses="secondary"
      description={
        <>
          <p className="text-label">Click to view schools reports.</p>
          <div className="mt-30" style={{ display: 'grid', gap: '20px' }}>
            {actions.map((action) => (
              <button
                key={action.id}
                className="clean-btn text-primary text-left"
                onClick={(e) => {
                  history.push(`/admin/${action.id}`);
                  e.target.blur();
                  closeModal();
                }}
              >
                {action.text}
              </button>
            ))}
          </div>
        </>
      }
    />
  );
}
